<template>
	<div class="home-container">
		<!-- 高级轮播图部分 -->
		<div class="banner-section">
			<el-carousel :interval="bannerList[currentIndex].interval" arrow="always" trigger="click" :autoplay="true"
				class="premium-carousel">
				<el-carousel-item v-for="(item, index) in bannerList" :key="item.id">
					<div class="carousel-container">
						<template>
							<div class="media-wrapper">
								<img :src="item.src" class="carousel-media" loading="lazy" :alt="item.title || '轮播图'"
									:style="{ objectPosition: item.focus || 'center' }" />
								<div class="media-overlay"></div>
								<div class="media-caption">
									<h3 v-if="item.title">{{ item.title }}</h3>
									<p v-if="item.description">{{ item.description }}</p>
									<el-button v-if="item.buttonText" type="primary" round class="caption-button">
										{{ item.buttonText }}
									</el-button>
								</div>
							</div>
						</template>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>

		<!-- 服务部分 -->
		<div class="services-section">
			<div class="split-screen-services">
				<!-- 左侧导航 -->
				<div class="service-nav">
					<div class="nav-header">
						<div class="section-tag">{{ $t('homeFst.services.tag') }}</div>
						<h2 class="section-title" v-html="$t('homeFst.services.title')"></h2>
					</div>
					<ul class="service-list">
						<li v-for="(service, index) in serviceList" :key="index" :class="{ active: activeService === index }"
							@click="activeService = index">
							<div class="service-icon">
								<i :class="service.icon"></i>
							</div>
							<span>{{ service.title }}</span>
							<i class="el-icon-arrow-right"></i>
						</li>
					</ul>
				</div>

				<!-- 右侧内容 -->
				<div class="service-content">
					<transition-group name="fade" mode="out-in">
						<div v-for="(service, index) in serviceList" v-show="activeService === index" :key="index"
							class="content-item">
							<img :src="service.image" :alt="service.title" class="content-bg" loading="lazy">
							<div class="content-overlay"></div>
							<div class="content-text">
								<h3>{{ service.title }}</h3>
								<p>{{ service.desc }}</p>
								<ul class="feature-list">
									<li v-for="(feature, i) in service.features" :key="i">
										<i class="el-icon-check"></i>
										<span v-html="feature"></span>
									</li>
								</ul>

							</div>
						</div>
					</transition-group>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Home',
		data() {
			const rawServices = this.$t('homeFst.services.list', this.$i18n.locale, true);
			return {
				bannerList: [{
						id: 1,
						src: require('@/assets/images/s1.jpg'),
						type: 'image',
						interval: 5000
					},
					{
						id: 2,
						src: require('@/assets/images/s4.jpg'),
						type: 'image',
						interval: 5000
					},
					{
						id: 3,
						src: require('@/assets/images/s3.jpg'),
						type: 'image',
						interval: 5000
					},
				],
				currentIndex: 0,
				activeService: 0,
				videoHasSound: [], // 是否有声音
				videoPlaying: [], // 是否播放中
				imagesLoaded: false,
			};
		},
		computed: {
			// ✅ 关键：使用 computed 绑定 $t()
			serviceList() {
				const rawServices = this.$t('homeFst.services.list');
				return [{
						...rawServices[0],
						icon: 'el-icon-refrigerator',
						image: require('@/assets/images/ll.png')
					},
					{
						...rawServices[1],
						icon: 'el-icon-warning',
						image: require('@/assets/images/wxp.png')
					},
					{
						...rawServices[2],
						icon: 'el-icon-first-aid-kit',
						image: require('@/assets/images/yy.png')
					},
					{
						...rawServices[3],
						icon: 'el-icon-lightning',
						image: require('@/assets/images/dd.png')
					},
					{
						...rawServices[4],
						icon: 'el-icon-truck',
						image: require('@/assets/images/cdj.png')
					},
				];
			},
		},
		watch: {
			// 语言切换时重新预加载
			'$i18n.locale'() {
				this.preloadImages();
			},
		},
		methods: {
			preloadImages() {
				this.serviceList.forEach(service => {
					const img = new Image();
					img.src = service.image;
				});
			},
		},
		mounted() {
			this.preloadImages();
		}
	};
</script>

<style lang="scss" scoped>
	.home-container {
		width: 100%;
		overflow: hidden;
		background: linear-gradient(rgba(245, 250, 255, 0.92), rgba(245, 250, 255, 0.92)),
			url('../assets/images/背景1.jpg') center/cover no-repeat;
	}

	/* 轮播图样式 */
	.banner-section {
		position: relative;
		width: 100%;
		height: 90vh;
		/* Full viewport height */
		overflow: hidden;

		.premium-carousel {
			height: 100%;

			::v-deep .el-carousel__container {
				height: 100%;
			}

			::v-deep .el-carousel__item {
				width: 100%;
				height: 100%;
			}

			::v-deep .el-carousel__arrow {
				width: 48px;
				height: 48px;
				font-size: 24px;
				background-color: rgba(0, 0, 0, 0.25);
				backdrop-filter: blur(4px);
				border: 1px solid rgba(255, 255, 255, 0.1);
				transition: all 0.3s ease;
			}

			::v-deep .el-carousel__indicators {
				bottom: 40px;
				z-index: 10;

				.el-carousel__indicator {
					padding: 8px 4px;

					.el-carousel__button {
						width: 8px;
						height: 8px;
						border-radius: 4px;
						background-color: rgba(255, 255, 255, 0.5);
						transition: all 0.4s cubic-bezier(0.22, 0.61, 0.36, 1);
					}

					&.is-active .el-carousel__button {
						width: 24px;
						background-color: #fff;
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
					}
				}
			}
		}

		.media-wrapper {
			position: relative;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		.carousel-media {
			width: 100%;
			// height: 100%;
			object-fit: cover;
			object-position: center;
		}

		.media-caption {
			position: absolute;
			bottom: 15%;
			left: 10%;
			max-width: 50%;
			color: white;
			z-index: 2;
			text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
			transform: translateY(20px);
			opacity: 0;
			animation: fadeInUp 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0.3s forwards;

			h3 {
				font-size: 2.5rem;
				font-weight: 600;
				margin-bottom: 1rem;
				line-height: 1.2;
			}

			p {
				font-size: 1.1rem;
				margin-bottom: 1.5rem;
				line-height: 1.5;
				opacity: 0.9;
			}

			.caption-button {
				padding: 12px 28px;
				font-weight: 500;
				letter-spacing: 0.5px;
				background: rgba(255, 255, 255, 0.1);
				border: 1px solid rgba(255, 255, 255, 0.3);
				backdrop-filter: blur(4px);
				transition: all 0.3s ease;

				&:hover {
					background: rgba(255, 255, 255, 0.2);
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				}
			}
		}

		.media-controls {
			position: absolute;
			bottom: 20px;
			right: 20px;
			display: flex;
			gap: 12px;
			z-index: 3;

			.control-btn {
				width: 36px;
				height: 36px;
				border-radius: 50%;
				background: rgba(0, 0, 0, 0.4);
				backdrop-filter: blur(4px);
				border: 1px solid rgba(255, 255, 255, 0.2);
				color: white;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.3s ease;

				&:hover {
					background: rgba(0, 0, 0, 0.6);
					transform: scale(1.1);
				}

				i {
					font-size: 16px;
				}

				&.sound-off {
					opacity: 0.6;
				}

				&.paused {
					opacity: 0.6;
				}
			}
		}

		@keyframes fadeInUp {
			from {
				transform: translateY(20px);
				opacity: 0;
			}

			to {
				transform: translateY(0);
				opacity: 1;
			}
		}
	}

	.carousel-container {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.carousel-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
		display: block;
	}

	/* 服务部分样式 */
	.services-section {
		padding: 4rem 0;

		.split-screen-services {
			display: flex;
			max-width: 1200px;
			margin: 0 auto;
			padding: 0 20px;
			gap: 30px;
		}

		.service-nav {
			flex: 0 0 320px;
			background: white;
			border-radius: 12px;
			padding: 30px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

			.nav-header {
				margin-bottom: 30px;

				.section-tag {
					color: #409EFF;
					font-size: 14px;
					font-weight: 600;
					margin-bottom: 10px;
				}

				.section-title {
					font-size: 24px;
					line-height: 1.4;
					color: #333;
					margin-bottom: 20px;
				}
			}

			.service-list {
				list-style: none;
				padding: 0;
				margin: 0;

				li {
					display: flex;
					align-items: center;
					padding: 15px 5px;
					margin-bottom: 8px;
					border-radius: 8px;
					cursor: pointer;
					transition: all 0.3s ease;
					color: #666;

					&:hover {
						background-color: #f0f7ff;
						color: #409EFF;
					}

					&.active {
						background-color: #e6f1ff;
						color: #409EFF;
					}

					.service-icon {
						margin-right: 15px;
						font-size: 18px;
					}

					span {
						flex: 1;
					}

					.el-icon-arrow-right {
						font-size: 14px;
					}
				}
			}
		}

		.service-content {
			flex: 1;
			position: relative;
			border-radius: 12px;
			overflow: hidden;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
			min-height: 400px;

			.content-item {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				transition: opacity 0.3s ease;

				.content-bg {
					width: 100%;
					height: 100%;
					object-fit: cover;
					object-position: center;
					display: block;
				}

				.content-overlay {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);
				}

				.content-text {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					padding: 40px;
					color: white;
					display: flex;
					flex-direction: column;
					justify-content: center;

					h3 {
						font-size: 28px;
						margin-bottom: 20px;
					}

					p {
						font-size: 16px;
						line-height: 1.6;
						margin-bottom: 25px;
						max-width: 600px;
					}

					.feature-list {
						list-style: none;
						padding: 0;
						margin-bottom: 30px;

						li {
							margin-bottom: 12px;
							font-size: 15px;

							.el-icon-check {
								margin-right: 8px;
							}
						}
					}
				}
			}
		}
	}

	/* 过渡动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s ease;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	/* ----------------- 移动端优化 ----------------- */

	@media screen and (max-width: 992px) {
		.services-section {
			.split-screen-services {
				flex-direction: column;
				gap: 20px;
			}

			.service-nav {
				flex: 1;
				margin-bottom: 20px;
				padding: 20px;
			}

			.service-content {
				min-height: 350px;

				.content-text {
					padding: 20px;

					h3 {
						font-size: 24px;
					}

					p {
						font-size: 14px;
					}

					.feature-list li {
						font-size: 14px;
					}
				}
			}
		}

		.banner-section {

			/* 用padding-bottom撑高，保持宽高比 */
			::v-deep .el-carousel__container {
				/* 16:9 比例 */
				height: auto !important;
			}

			/* 轮播指示器调整 */
			::v-deep .el-carousel__indicators {
				bottom: 15px;
			}

			/* 图片自适应 */
			.carousel-media {
				height: auto !important;
				object-fit: contain !important;
				object-position: center !important;
				background-color: #000;
				display: block;
			}

			.media-wrapper,
			.carousel-container {
				height: auto !important;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.services-section {
			padding: 2rem 1rem;

			.service-nav {
				padding: 15px;
			}

			.service-content {
				min-height: 300px;

				.content-text {
					padding: 15px;

					h3 {
						font-size: 20px;
					}

					p {
						font-size: 13px;
					}

					.feature-list li {
						font-size: 13px;
					}
				}
			}
		}

		.banner-section {
			::v-deep .el-carousel__container {
				// padding-bottom: 75%;
				/* 4:3 比例 */
			}
		}
	}

	@media screen and (max-width: 576px) {
		.services-section {
			.service-nav {
				padding: 10px;

				.section-title {
					font-size: 1.25rem;
				}

				.service-list li {
					padding: 10px 12px;
					font-size: 13px;
				}
			}
		}

		.banner-section {
			::v-deep .el-carousel__container {
				// padding-bottom: 100%;
				/* 1:1 比例 */
			}
		}
	}

	@media screen and (max-width: 767px) {
		.home-container {
			margin-top: 13vh;
		}

		.banner-section {
			height: 25vh !important;
			max-height: none !important;
			overflow: visible !important;
		}

		// .banner-section .premium-carousel,
		// .banner-section .premium-carousel ::v-deep .el-carousel__container,
		// .banner-section .premium-carousel ::v-deep .el-carousel__item,
		// .banner-section .carousel-container,
		// .banner-section .media-wrapper {
		// 	height: auto !important;
		// }
		.banner-section .premium-carousel .el-carousel__item {
			height: auto !important;
		}

		.banner-section.el-carousel__container {
			padding-bottom: auto !important;
		}

		.carousel-media {
			width: 100% !important;
			height: auto !important;
			object-fit: contain !important;
			object-position: center !important;
			background-color: #000;
			display: block;
		}

		/* 隐藏轮播左右箭头 */
		.banner-section ::v-deep .el-carousel__arrow {
			display: none !important;
		}
	}
</style>